import moment from 'moment';

// W-0626 — Export client-side (CSV abre no Excel). O backend NÃO expõe endpoint
// de Excel (read-only, GET-only), então geramos o arquivo no browser.
// Separador ';' + decimal ',' (padrão pt-BR Excel) + BOM UTF-8 (acentos).

const SEP = ';';

const fmtValorBr = (val) =>
  new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: false,
  }).format(val || 0);

const fmtTaxaBr = (val) =>
  val === null || val === undefined
    ? ''
    : new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 4,
        useGrouping: false,
      }).format(val);

const fmtDataBr = (val) => (val ? moment(val).format('DD/MM/YYYY') : '');

// Escapa um campo: aspas duplas se contiver separador/aspas/quebra.
const campo = (valor) => {
  const texto = valor === null || valor === undefined ? '' : String(valor);
  if (texto.indexOf(SEP) >= 0 || texto.indexOf('"') >= 0 || texto.indexOf('\n') >= 0) {
    return `"${texto.replace(/"/g, '""')}"`;
  }
  return texto;
};

const linha = (colunas) => colunas.map(campo).join(SEP);

export const exportarDemonstrativoCsv = (resultado) => {
  const familias = (resultado && resultado.familias) || [];
  const totalGeral = (resultado && resultado.total_geral) || {
    saldo: 0,
    custo: 0,
    valor_presente: 0,
  };

  const linhas = [];
  linhas.push(
    linha([
      'Família',
      'Boleto',
      'Proposta',
      'Data',
      'Saldo',
      'Custo',
      'Valor Presente',
      'Periodicidade',
      'Taxa Juros',
      'Capitaliza Ano',
      'Resíduo',
    ])
  );

  familias.forEach((familia) => {
    const itens = familia.itens || [];
    itens.forEach((item) => {
      linhas.push(
        linha([
          familia.nome_da_familia,
          item.codigo_boleto,
          item.codigo_proposta,
          fmtDataBr(item.data),
          fmtValorBr(item.saldo),
          fmtValorBr(item.custo),
          fmtValorBr(item.valor_presente),
          item.per_venc,
          fmtTaxaBr(item.taxa_juros),
          item.cap_ano,
          item.tem_residuo,
        ])
      );
    });

    const subtotal = familia.subtotal || {
      saldo: 0,
      custo: 0,
      valor_presente: 0,
    };
    linhas.push(
      linha([
        `Subtotal ${familia.nome_da_familia}`,
        '',
        '',
        '',
        fmtValorBr(subtotal.saldo),
        fmtValorBr(subtotal.custo),
        fmtValorBr(subtotal.valor_presente),
        '',
        '',
        '',
        '',
      ])
    );
  });

  linhas.push(
    linha([
      'Total Geral',
      '',
      '',
      '',
      fmtValorBr(totalGeral.saldo),
      fmtValorBr(totalGeral.custo),
      fmtValorBr(totalGeral.valor_presente),
      '',
      '',
      '',
      '',
    ])
  );

  const conteudo = `﻿${linhas.join('\r\n')}`;
  const blob = new Blob([conteudo], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `demonstrativo-financeiro-${moment().format('YYYYMMDD-HHmmss')}.csv`;
  link.click();
  window.URL.revokeObjectURL(url);
  link.remove();
};
